/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  IngredientDetail,
  IngredientsListParams,
  IngredientsRemoteBatchCreateParams,
  IngredientsRemoteRetrieveParams,
  IngredientsRemoteUpdateParams,
  PaginatedIngredientListList,
  PatchedIngredientDetail,
  RemoteIngredient,
  RemoteIngredientBase
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const ingredientsList = (
    params?: IngredientsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedIngredientListList>(
      {url: `/ingredients/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getIngredientsListQueryKey = (params?: IngredientsListParams,) => {
    return [`/ingredients/`, ...(params ? [params]: [])] as const;
    }

    
export const getIngredientsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsList>>, TError = unknown>(params?: IngredientsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsList>>> = ({ signal, pageParam }) => ingredientsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsList>>>
export type IngredientsListInfiniteQueryError = unknown

export const useIngredientsListInfinite = <TData = Awaited<ReturnType<typeof ingredientsList>>, TError = unknown>(
 params?: IngredientsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getIngredientsListQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsList>>, TError = unknown>(params?: IngredientsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsList>>> = ({ signal }) => ingredientsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsListQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsList>>>
export type IngredientsListQueryError = unknown

export const useIngredientsList = <TData = Awaited<ReturnType<typeof ingredientsList>>, TError = unknown>(
 params?: IngredientsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const ingredientsRetrieve = (
    ingredientUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<IngredientDetail>(
      {url: `/ingredients/${ingredientUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getIngredientsRetrieveQueryKey = (ingredientUuid: string,) => {
    return [`/ingredients/${ingredientUuid}/`] as const;
    }

    
export const getIngredientsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsRetrieve>>, TError = unknown>(ingredientUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsRetrieveQueryKey(ingredientUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsRetrieve>>> = ({ signal }) => ingredientsRetrieve(ingredientUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ingredientUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsRetrieve>>>
export type IngredientsRetrieveInfiniteQueryError = unknown

export const useIngredientsRetrieveInfinite = <TData = Awaited<ReturnType<typeof ingredientsRetrieve>>, TError = unknown>(
 ingredientUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsRetrieveInfiniteQueryOptions(ingredientUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getIngredientsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsRetrieve>>, TError = unknown>(ingredientUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsRetrieveQueryKey(ingredientUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsRetrieve>>> = ({ signal }) => ingredientsRetrieve(ingredientUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ingredientUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsRetrieve>>>
export type IngredientsRetrieveQueryError = unknown

export const useIngredientsRetrieve = <TData = Awaited<ReturnType<typeof ingredientsRetrieve>>, TError = unknown>(
 ingredientUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsRetrieveQueryOptions(ingredientUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const ingredientsUpdate = (
    ingredientUuid: string,
    ingredientDetail: NonReadonly<IngredientDetail>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<IngredientDetail>(
      {url: `/ingredients/${ingredientUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ingredientDetail
    },
      options);
    }
  


export const getIngredientsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<IngredientDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ingredientsUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<IngredientDetail>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ingredientsUpdate>>, {ingredientUuid: string;data: NonReadonly<IngredientDetail>}> = (props) => {
          const {ingredientUuid,data} = props ?? {};

          return  ingredientsUpdate(ingredientUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IngredientsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ingredientsUpdate>>>
    export type IngredientsUpdateMutationBody = NonReadonly<IngredientDetail>
    export type IngredientsUpdateMutationError = unknown

    export const useIngredientsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<IngredientDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof ingredientsUpdate>>,
        TError,
        {ingredientUuid: string;data: NonReadonly<IngredientDetail>},
        TContext
      > => {

      const mutationOptions = getIngredientsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const ingredientsPartialUpdate = (
    ingredientUuid: string,
    patchedIngredientDetail: NonReadonly<PatchedIngredientDetail>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<IngredientDetail>(
      {url: `/ingredients/${ingredientUuid}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedIngredientDetail
    },
      options);
    }
  


export const getIngredientsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsPartialUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<PatchedIngredientDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ingredientsPartialUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<PatchedIngredientDetail>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ingredientsPartialUpdate>>, {ingredientUuid: string;data: NonReadonly<PatchedIngredientDetail>}> = (props) => {
          const {ingredientUuid,data} = props ?? {};

          return  ingredientsPartialUpdate(ingredientUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IngredientsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ingredientsPartialUpdate>>>
    export type IngredientsPartialUpdateMutationBody = NonReadonly<PatchedIngredientDetail>
    export type IngredientsPartialUpdateMutationError = unknown

    export const useIngredientsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsPartialUpdate>>, TError,{ingredientUuid: string;data: NonReadonly<PatchedIngredientDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof ingredientsPartialUpdate>>,
        TError,
        {ingredientUuid: string;data: NonReadonly<PatchedIngredientDetail>},
        TContext
      > => {

      const mutationOptions = getIngredientsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a remote ingredient.
 */
export const ingredientsRemoteRetrieve = (
    remoteId: string,
    params?: IngredientsRemoteRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<RemoteIngredient>(
      {url: `/ingredients/remote/${remoteId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getIngredientsRemoteRetrieveQueryKey = (remoteId: string,
    params?: IngredientsRemoteRetrieveParams,) => {
    return [`/ingredients/remote/${remoteId}`, ...(params ? [params]: [])] as const;
    }

    
export const getIngredientsRemoteRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError = void>(remoteId: string,
    params?: IngredientsRemoteRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsRemoteRetrieveQueryKey(remoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>> = ({ signal, pageParam }) => ingredientsRemoteRetrieve(remoteId,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(remoteId),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsRemoteRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>>
export type IngredientsRemoteRetrieveInfiniteQueryError = void

export const useIngredientsRemoteRetrieveInfinite = <TData = Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError = void>(
 remoteId: string,
    params?: IngredientsRemoteRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsRemoteRetrieveInfiniteQueryOptions(remoteId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getIngredientsRemoteRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError = void>(remoteId: string,
    params?: IngredientsRemoteRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIngredientsRemoteRetrieveQueryKey(remoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>> = ({ signal }) => ingredientsRemoteRetrieve(remoteId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(remoteId),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type IngredientsRemoteRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>>
export type IngredientsRemoteRetrieveQueryError = void

export const useIngredientsRemoteRetrieve = <TData = Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError = void>(
 remoteId: string,
    params?: IngredientsRemoteRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ingredientsRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getIngredientsRemoteRetrieveQueryOptions(remoteId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create or update a remote ingredient.
 */
export const ingredientsRemoteUpdate = (
    remoteId: string,
    remoteIngredient: NonReadonly<RemoteIngredient>,
    params?: IngredientsRemoteUpdateParams,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<RemoteIngredient>(
      {url: `/ingredients/remote/${remoteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: remoteIngredient,
        params
    },
      options);
    }
  


export const getIngredientsRemoteUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteUpdate>>, TError,{remoteId: string;data: NonReadonly<RemoteIngredient>;params?: IngredientsRemoteUpdateParams}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteUpdate>>, TError,{remoteId: string;data: NonReadonly<RemoteIngredient>;params?: IngredientsRemoteUpdateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ingredientsRemoteUpdate>>, {remoteId: string;data: NonReadonly<RemoteIngredient>;params?: IngredientsRemoteUpdateParams}> = (props) => {
          const {remoteId,data,params} = props ?? {};

          return  ingredientsRemoteUpdate(remoteId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IngredientsRemoteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ingredientsRemoteUpdate>>>
    export type IngredientsRemoteUpdateMutationBody = NonReadonly<RemoteIngredient>
    export type IngredientsRemoteUpdateMutationError = void

    export const useIngredientsRemoteUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteUpdate>>, TError,{remoteId: string;data: NonReadonly<RemoteIngredient>;params?: IngredientsRemoteUpdateParams}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof ingredientsRemoteUpdate>>,
        TError,
        {remoteId: string;data: NonReadonly<RemoteIngredient>;params?: IngredientsRemoteUpdateParams},
        TContext
      > => {

      const mutationOptions = getIngredientsRemoteUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create or update a batch of remote ingredients.
 */
export const ingredientsRemoteBatchCreate = (
    remoteIngredientBase: NonReadonly<RemoteIngredientBase[]>,
    params?: IngredientsRemoteBatchCreateParams,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<RemoteIngredientBase[]>(
      {url: `/ingredients/remote/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: remoteIngredientBase,
        params
    },
      options);
    }
  


export const getIngredientsRemoteBatchCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>, TError,{data: NonReadonly<RemoteIngredientBase[]>;params?: IngredientsRemoteBatchCreateParams}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>, TError,{data: NonReadonly<RemoteIngredientBase[]>;params?: IngredientsRemoteBatchCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>, {data: NonReadonly<RemoteIngredientBase[]>;params?: IngredientsRemoteBatchCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  ingredientsRemoteBatchCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IngredientsRemoteBatchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>>
    export type IngredientsRemoteBatchCreateMutationBody = NonReadonly<RemoteIngredientBase[]>
    export type IngredientsRemoteBatchCreateMutationError = void

    export const useIngredientsRemoteBatchCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>, TError,{data: NonReadonly<RemoteIngredientBase[]>;params?: IngredientsRemoteBatchCreateParams}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof ingredientsRemoteBatchCreate>>,
        TError,
        {data: NonReadonly<RemoteIngredientBase[]>;params?: IngredientsRemoteBatchCreateParams},
        TContext
      > => {

      const mutationOptions = getIngredientsRemoteBatchCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    